import { defineMessages } from "react-intl";

export const messages = defineMessages({
    cardRelationshipNameMessage: {
        id: "fastshift.card-relationship.relationship-name",
        defaultMessage: "{name}",
        description: "Name of the relationship"
    },
    cardRelationshipTitle: {
        id: "fastshift.card-relationship.relationship-title",
        defaultMessage: "{title}",
        description: "Title of the relationship"
    }
});
